<div class="layout-column custom-panel full-width full-height">
  <div class="flex layout-column padding-10">

    <div *ngFor="let option of options; let isFirst = first; trackBy: trackByOption"
         class="layout-row layout-align-start-center pointer"
         [class.margin-top-10]="!isFirst"
         [appBringozIdGenerator]="option"
         (click)="onToggleSortTypeChange(option , sortBy === option && sortType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100">{{ ('SORT_OPTIONS.' + option) | translate }}</span>
      <bringoz-icon *ngIf="sortBy === option && sortType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === option && sortType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

  </div>
</div>
